// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PartnerInfoAPIModel,
    PartnerInfoAPIModelFromJSON,
    PartnerInfoAPIModelFromJSONTyped,
    PartnerInfoAPIModelToJSON,
    PhoneDataAPIModel,
    PhoneDataAPIModelFromJSON,
    PhoneDataAPIModelFromJSONTyped,
    PhoneDataAPIModelToJSON,
    ProfileIdentificationStatusAPIModel,
    ProfileIdentificationStatusAPIModelFromJSON,
    ProfileIdentificationStatusAPIModelFromJSONTyped,
    ProfileIdentificationStatusAPIModelToJSON,
    UpdatePhoneResponseDTOAPIModel,
    UpdatePhoneResponseDTOAPIModelFromJSON,
    UpdatePhoneResponseDTOAPIModelFromJSONTyped,
    UpdatePhoneResponseDTOAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface InitialDataAPIModel
 */
export interface InitialDataAPIModel {
    /**
     * 
     * @type {string}
     * @memberof InitialDataAPIModel
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof InitialDataAPIModel
     */
    accountId: number;
    /**
     * 
     * @type {UpdatePhoneResponseDTOAPIModel}
     * @memberof InitialDataAPIModel
     */
    confirmation?: UpdatePhoneResponseDTOAPIModel;
    /**
     * 
     * @type {PhoneDataAPIModel}
     * @memberof InitialDataAPIModel
     */
    phone?: PhoneDataAPIModel;
    /**
     * 
     * @type {ProfileIdentificationStatusAPIModel}
     * @memberof InitialDataAPIModel
     */
    status?: ProfileIdentificationStatusAPIModel;
    /**
     * 
     * @type {PartnerInfoAPIModel}
     * @memberof InitialDataAPIModel
     */
    partner?: PartnerInfoAPIModel;
}

export function InitialDataAPIModelFromJSON(json: any): InitialDataAPIModel {
    return InitialDataAPIModelFromJSONTyped(json, false);
}

export function InitialDataAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitialDataAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'accountId': json['accountId'],
        'confirmation': !exists(json, 'confirmation') ? undefined : UpdatePhoneResponseDTOAPIModelFromJSON(json['confirmation']),
        'phone': !exists(json, 'phone') ? undefined : PhoneDataAPIModelFromJSON(json['phone']),
        'status': !exists(json, 'status') ? undefined : ProfileIdentificationStatusAPIModelFromJSON(json['status']),
        'partner': !exists(json, 'partner') ? undefined : PartnerInfoAPIModelFromJSON(json['partner']),
    };
}

export function InitialDataAPIModelToJSON(value?: InitialDataAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'accountId': value.accountId,
        'confirmation': UpdatePhoneResponseDTOAPIModelToJSON(value.confirmation),
        'phone': PhoneDataAPIModelToJSON(value.phone),
        'status': ProfileIdentificationStatusAPIModelToJSON(value.status),
        'partner': PartnerInfoAPIModelToJSON(value.partner),
    };
}


